import React from "react";
import ValentinesDayHeart from "../../assets/valentines_day/valentines_day_heart.png";
import ValentinesDayMonth from "../../assets/valentines_day/valentines_day_month.png";
import ValentinesDayPromoCode from "../../assets/valentines_day/valentines_day_promo_code.png";
import ValentinesDayGift from "../../assets/valentines_day/valentines_day_gift.png";

import CardInteligComp from "../../assets/valentines_day/intelig-compet.png";
import CardBusinessTrends from "../../assets/valentines_day/business-trends.png";
import CardArquitetoDeNegocios from "../../assets/valentines_day/arquitet-negocios.png";
import CardACommerce from "../../assets/valentines_day/a-commerce.png";
import CardPraticandoAArquitetura from "../../assets/valentines_day/pratic-arquitet.png";
import CardDesenvolvimentoTI from "../../assets/valentines_day/desenv-TI.png";

import "../../styles/ValentinesDay.css";
// import Footer from '../footer/footer'
// import Simplefooter from '../footer/simplefooter'

const ValentinesDay = () => {
  let width = window.innerWidth;
  console.log(width);
  return (
    <section className="section-valentines-day">
      <div className="div-banner-valentines-day">
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        {width > 1060 ? (
          <div className="div-heart">
            <img src={ValentinesDayHeart} className="img-heart" alt=''/>
          </div>
        ) : null}
        <div className="div-group-phrases-valentines-day">
          <img src={ValentinesDayMonth} alt=''/>
          <img src={ValentinesDayGift} alt=''/>
          <br />
          <br />
          <img id="img-promo-code" src={ValentinesDayPromoCode} />
        </div>
      </div>
      <div className="div-courses-valentines-day">
        <div className="groupCardsValentines">
          <a href="https://bit.ly/3t3unK8" target="_blank">
            <img src={CardInteligComp} alt=''/>
          </a>
          <a href="https://bit.ly/3sYW1bl" target="_blank">
            <img src={CardBusinessTrends} alt=''/>
          </a>
          <a href="https://bit.ly/3NGtRtB" target="_blank">
            <img src={CardArquitetoDeNegocios} alt=''/>
          </a>
        </div>
        <div className="groupCardsValentines">
          <a href="https://bit.ly/3a1OUsb" target="_blank">
            <img src={CardACommerce} alt=''/>
          </a>
          <a href="https://bit.ly/3PN91KM" target="_blank">
            <img src={CardPraticandoAArquitetura} alt='' />
          </a>
          <a href="https://bit.ly/3x3kmhA" target="_blank">
            <img src={CardDesenvolvimentoTI} alt='' />
          </a>
        </div>
      </div>
    </section>
  );
};

export default ValentinesDay;



// WEBPACK FOOTER //
// ./src/components/valentinesDay/valentinesDay.js